export default "__VITE_ASSET__65afc559__"